<template>
  <div class="flex items-center justify-center mobile:gap-1 laptop:gap-2">
    <div class="font-medium mobile:text-sm mobile:hidden laptop:hidden laptop:text-base desktop:block text-gray-900">
      Go Live
    </div>
    <label class="flex items-center cursor-pointer">
      <!-- toggle -->
      <div class="relative">
        <input :checked="isOnline" type="checkbox" class="sr-only"  @change="handleToggle">
        <div class="block w-24 h-9 rounded-full" :class="isOnline ? 'bg-green-500' : 'bg-gray-200'"></div>
        <div class="absolute left-1.5 top-2  w-5 h-5 rounded-full transition transform"
          :class="isOnline ? 'translate-x-16 bg-white' : 'bg-gray-600'">
          <div class="absolute left-1.5 top-1.5 w-2 h-2 rounded-full" :class="isOnline ? 'bg-green-500' : 'bg-white'"></div>
        </div>
        <!-- Status labels inside the slider -->
        <div class="absolute inset-0 flex items-center px-2 w-full"
          :class="isOnline ? 'justify-start' : 'justify-end'">
          <span class="text-base font-medium" :class="isOnline ? 'text-white' : 'text-gray-300 hidden'">Online</span>
          <span class="text-base font-medium" :class="isOnline ? 'text-white hidden' : 'text-gray-600'">Offline</span>
        </div>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  props:['user'],
  data() {
    return {
     
    }
  },

  computed: {
    isOnline(){
      return (this.user.user.active == '1') ? true : false
    }
  },

  methods: {
    handleToggle(event) {
      this.$emit('toggle', event.target.checked);
    }
  }
}
</script>